module.exports = __webpack_public_path__ + "img/puzzlePiece_w.2259c835.svg";